import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { CalloutNodeView } from "@/components/editor/nodeviews/CalloutNodeView";

export const CalloutBlock = Node.create({
  name: "calloutBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      calloutType: { default: "note" },
      title: { default: "" },
      text: { default: "" },
      collapsible: { default: false },
      // Free-form color override — when non-empty, the LaTeX/Typst
      // renders use this color for the tcolorbox fill/frame instead
      // of the variant default (note/tip/warning/important/example).
      // Accepts any xcolor / CSS color name (red, ForestGreen, etc.).
      color: { default: "" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="callout-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "callout-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CalloutNodeView);
  },
});
